import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded';
import { Box, FormControlLabel, Paper, Radio, Typography } from '@mui/material';

import { Label } from '@components/Label';

import { AddressId, IAddress } from '@components/FormAddressFields/types';
import { getAddressInformation } from '@utils/getAddressInformation';

interface AddressItemProps {
  address: IAddress;
  isSelected: boolean;
  onSelect: (addressId: AddressId) => void;
}

export const AddressItem = ({ address, isSelected, onSelect }: AddressItemProps) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        transition: (theme) => theme.transitions.create('all'),
        ...(isSelected && {
          boxShadow: (theme) => theme.customShadows.z12,
        }),
      }}
    >
      <FormControlLabel
        control={
          <Radio
            onChange={() => address.id && onSelect(address.id)}
            checked={isSelected}
            checkedIcon={<CheckCircleRounded />}
          />
        }
        label={
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', ml: 1 }}>
            <Typography variant="body2">
              {address.description} <br />
              {getAddressInformation(address)}
            </Typography>
            {address.default && (
              <Label variant="soft" color="info">
                Default
              </Label>
            )}
          </Box>
        }
        sx={{ py: 3, px: 2.5, flexGrow: 1, mr: 0 }}
        disableTypography
      />
    </Paper>
  );
};
